import { render, staticRenderFns } from "./SelectTipoClase.vue?vue&type=template&id=1fbac912&"
import script from "./SelectTipoClase.vue?vue&type=script&lang=js&"
export * from "./SelectTipoClase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports